const clientId = '1acchb0ietf8032ul136qihucp'
const userPool = 'us-west-2_aolmv8PAI'
const currentUrl = window.location.origin

module.exports.cognito = {
  REGION: 'us-west-2',
  USER_POOL_ID: userPool,
  APP_CLIENT_ID: clientId,
  IDENTITY_POOL_ID: 'us-west-2:44a444e4-0332-4142-94ba-b4686a359af7',
}

module.exports.authConfig = {
  ClientId: clientId,
  AppWebDomain: 'rancor.auth.us-west-2.amazoncognito.com',
  TokenScopesArray: ['openid', 'email', 'profile'],
  RedirectUriSignIn: `${currentUrl}/implicit/callback`,
  RedirectUriSignOut: `${currentUrl}`,
  IdentityProvider: 'okta',
  UserPoolId: userPool,
}
